import React, { Component } from 'react';
import { ModalBody, Modal, Row, Col } from "react-bootstrap";
import ReactImageMagnify from 'react-image-magnify';
import "./productMagnifier.scss";
/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { resetProductMagnifier } from '../../redux/actions/productMagnifierActions';
/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        productMagnifier: state.productMagnifier,
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    resetProductMagnifier
};

class ProductMagnifier extends Component {
    constructor(props) {
        super();
    }

    render() {
        const { show, imageUrl } = this.props.productMagnifier;
        return (
            <React.Fragment>
                <Modal size="md" centered className="popup-box" show={show ?? false}>
                    <ModalBody>
                        <div className="product-magnifier-content-holder">
                            <Row>
                                <Col>
                                    <div className='product-magnifier-close-btn' onClick={() => { this.props.resetProductMagnifier(); }}>X</div>
                                </Col>
                            </Row>
                            <Row className="text-center">
                                <Col md="12">
                                    <ReactImageMagnify {...{
                                        smallImage: {
                                            alt: 'image',
                                            isFluidWidth: true,
                                            src: imageUrl,
                                            onError: (e) => { e.target.onerror = null; e.target.src = "https://essstr.blob.core.windows.net/essimg/Small/Default.jpg" }
                                        },
                                        largeImage: {
                                            src: imageUrl,
                                            width: 1200,
                                            height: 1200,
                                            onError: (e) => { e.target.onerror = null; e.target.src = "https://essstr.blob.core.windows.net/essimg/Small/Default.jpg" }
                                        },
                                        isHintEnabled: true,
                                        enlargedImagePosition: 'over',
                                        shouldHideHintAfterFirstActivation: false
                                    }} />
                                    {/* <img className="img-fluid"
                                        src={imageUrl}
                                        onError={(e) => { e.target.onerror = null; e.target.src = "https://essstr.blob.core.windows.net/essimg/Small/Default.jpg" }}
                                    /> */}
                                </Col>
                            </Row>
                        </div>

                    </ModalBody>
                </Modal>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductMagnifier);